import React, { memo, useEffect } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

import { getPageById } from '@/actions/actions'
import { MainSidebar } from '@/components/MainSidebar/MainSidebar'
import { PageContent } from '@/components/PageContent/PageContent'
import { pageTypes } from '@/constants/common'
import { focusIds } from '@/constants/focus'
import { Container } from '@/containers/styles'
import { TabsPage } from '@/containers/TabsPage/TabsPage'
import useStore from '@/store/useStore'
import { getMainHomePath } from '@/utils/route'

function PageRaw() {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { page, setPage } = useStore((state) => state.page)

  const isTabPage = page?.pageType === pageTypes.TABS

  const pageIdFromUrl = pathname.split('/').pop()

  useEffect(() => {
    const controller = new AbortController()

    if (pageIdFromUrl) {
      void getPageById(`${pageIdFromUrl}${search}`, controller.signal)
    }

    return () => {
      controller.abort()
    }
  }, [pageIdFromUrl])

  useEffect(() => {
    return () => {
      setPage(null)
    }
  }, [])

  return (
    <Container focusId={`${focusIds.PAGE}${focusIds.CONTENT}`}>
      <MainSidebar
        focusIdPrefix={focusIds.PAGE}
        onBack={() => {
          navigate(getMainHomePath())
        }}
        disableSubMenuAutoOpen
      />
      {isTabPage ? <TabsPage /> : <PageContent />}
    </Container>
  )
}

export const Page = memo(PageRaw)
